import styled from "@emotion/styled"

const HeroScrollCaseItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  max-width: 181px;
  border: 1px solid #dddddd;
  padding: 40px 28px 20px 28px;
  border-radius: 16px;
  min-width: 236px;
  min-height: 206px;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    align-items: flex-start;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: 100%;
    min-width: auto;
    &:nth-of-type(3) {
      grid-column: 1 / -1;
    }
  }
`

export default HeroScrollCaseItem
